import './style.scss';

document.addEventListener('DOMContentLoaded', () => {
  const mobileMenuBtn = document.querySelector('.main-header__mobile-menu-btn');
  const mobileMenu = document.querySelector('.main-header__menu');

  mobileMenuBtn.addEventListener('click', () => {
    mobileMenuBtn.classList.toggle('main-header__mobile-menu-btn--active');
    mobileMenu.classList.toggle('main-header__menu--open');
    document.body.classList.toggle('menu--open');
  });
});
